import { DIGITAL_ACCOUNT_ROUTES } from '../../../../constants/routes';

export const STEPS: Array<{
  img: string;
  label: string;
  isCompleted?: boolean;
  isProgress?: boolean;
  path: string;
}> = [
  {
    img: '/images/digital_account/select_accounts.png',
    label: 'Hesab məlumatları',
    path: DIGITAL_ACCOUNT_ROUTES.currency,
  },
  {
    img: '/images/digital_account/company.png',
    label: 'Şirkət və əlaqə məlumatları',
    path: DIGITAL_ACCOUNT_ROUTES['company-info'],
  },
  {
    img: '/images/digital_account/founders.png',
    label: 'İmza sahibləri və Təsisçilər',
    path: DIGITAL_ACCOUNT_ROUTES['shareholders'],
  },
  {
    img: '/images/digital_account/business_query.png',
    label: 'Biznes sorğusu',
    path: DIGITAL_ACCOUNT_ROUTES['business-request'],
  },
  {
    img: '/images/digital_account/sign_documents.png',
    label: 'Sənədlərin imzalanması',
    path: DIGITAL_ACCOUNT_ROUTES['print-forms'],
  },
  {
    img: '/images/digital_account/video_call.png',
    label: 'Video zəng',
    path: DIGITAL_ACCOUNT_ROUTES['videocall'],
  },
];
